<template lang="pug">
.section
  .section-header
    h1 {{ $t("ui.theme_content") }}
  .section-body(style="max-width:1000px;")
    .row
      .col-12
        .card.mb-0
          .card-header
            .row.col-12
              .form-group.col-6.mb-1
                SubmitButton(
                  :loading="loading"
                  icon="fa fa-retweet"
                  :text="$t('ui.refresh')"
                  type="button"
                  @click="getThemeContentList()"
                  variant="primary"
                  size="sm"
                )
              .form-group.col-12(v-if="isAdmin && isEditAccess")
                b-button(v-b-modal.addThemeContent type="button" variant="info" size="sm")
                  i.fa.fa-plus
                  span.ml-1 {{ $t("ui.combine.add_theme_content") }}
          .card-body
            .row
              .col-12
                .clusterize-scroll.table-responsive
                  table.table.table-sm.table-bordered.table-striped.table-hover
                    thead.thead-light
                      tr
                        th.text-center(width="3%")
                          span #
                        th(width="8%")
                          span(:title="$t('ui.content_id')") {{ $t('ui.content_id') }}
                        th(width="8%")
                          span(:title="$t('ui.content_desc')") {{ $t('ui.content_desc') }}
                        th.text-center(width="8%")
                          span(:title="$t('ui.sequence')") {{ $t('ui.sequence') }}
                        th.text-center(width="5%" v-if="isAdmin && isEditAccess")
                          span(:title="$t('ui.action')") {{ $t('ui.action') }}
                    tbody.clusterize-content
                      tr(v-if="themeContentList.length == 0")
                        td(colspan="6").text-center
                          span {{ $t('message.no_data_available') }}
                      tr(v-for="(item, index) in themeContentList")
                        td.text-center
                          span(:title="index + 1") {{ index + 1 }}
                        td
                          span(:title="item.content_id") {{ item.content_id }}
                        td
                          span(:title="item.content_desc") {{ item.content_desc }}
                        td.text-center
                          span(:title="item.sequence") {{ item.sequence }}
                        td.actions.text-center.align-middle(v-if="isAdmin && isEditAccess")
                          span.mr-2
                            a.fa.fa-edit.btn.btn-ssm.btn-icon.btn-primary(
                              href="javascript:void(0)"
                              @click="onEdit(item)"
                              :title="$t('ui.edit')"
                              )
                          span
                            a.fa.fa-trash.btn.btn-ssm.btn-icon.btn-danger(
                              href="javascript:void(0)"
                              @click="onDelete(item)"
                              :title="$t('ui.delete')"
                              )

      addthemecontent(@clicked="addThemeContent" @failed="handleFailed")
      editthemecontent(ref="editthemecontent" :item="editSelectedThemeContent" @clicked="afterEdit" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import addthemecontent from "@/components/content/themecontent/addThemeContent.vue";
import editthemecontent from "@/components/content/themecontent/editThemeContent.vue";
import SubmitButton from "@/library/SubmitButton.vue";

export default {
  components: {
    SubmitButton,
    addthemecontent,
    editthemecontent
  },
  data: () => ({
    loading: false,
    editSelectedThemeContent: null,
    themeContentList: [],
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
  }),
  computed: {
    accountType() {
      return this.$store.getters.accountType;
    },
    isAdmin() {
      return this.$store.getters.accountType === 5;
    },
    isAdminMaster() {
      return [3,5].includes(this.$store.getters.accountType);
    },
    isEditAccess() {
      return this.$helpers.showActionButton("e_themecontent");
    }
  },
  mounted: function() {
    this.getThemeContentList();
  },
  methods: {
    onEdit(e) {
      this.editSelectedThemeContent = e;
      this.$refs.editthemecontent.$refs.editThemeContent.show();
    },
    afterEdit() {
      this.getThemeContentList();
      this.$helpers.showDialog(this.$t("ui.combine.edit_theme_content"), this.$t("message.success"), "success");
    },
    onDelete:function(e) {
      this.$helpers
        .alert({
          title: this.$t("ui.delete"),
          text: this.$t("message.delete_theme_content_confirm", { themecontent: e.content_id }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmDelete(e);
          }
        });
    },
    confirmDelete: function(e) {
      let url = config.deleteContentUrl();

      var json = {
        auth_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.loginId,
        content_id: e.content_id
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.getThemeContentList();
                this.$helpers.showDialog(this.$t("ui.delete"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getThemeContentList: function() {
      let url = config.getContentListUrl();

      var json = {
        auth_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.loginId,
      }

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;

              if (this.feedback.success == true) {
                this.themeContentList = response.data.dt;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },

    addThemeContent: function() {
      this.getThemeContentList();

      this.$helpers.showDialog(this.$t("ui.combine.add_theme_content"), this.$t("message.success"), "success");
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>